import React, { useContext } from 'react';
import type { LayoutRectangle } from 'react-native';

import { PerformanceType } from '../ExtensionManager/types';
import { setNodePerformanceAttrs } from '../types';

export interface INodePerformanceContext {
  setNodePerformance?: (attrs: setNodePerformanceAttrs) => void;
  getNodePerformance?: (id: string) => { progress?: number; meta?: string };
  setNodeLayoutParams?: (nodeId: string, nodeType: string, layoutParams: LayoutRectangle) => void;
  nodePerformanceMap?: Map<string, PerformanceType>;
}

export const NodePerformanceContext = React.createContext<Partial<INodePerformanceContext>>({
  setNodePerformance: () => {},
});

export const useNodePerformanceContext = () => useContext(NodePerformanceContext);
